import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-topic-redirect",
  template: "",
  standalone: false,
})
export class TopicRedirectComponent {
  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.route.paramMap.subscribe((params) => {
      const topic = params.get("topic");
      this.router.navigate(["/search"], {
        queryParams: topic ? { topics: topic } : {},
        replaceUrl: true,
      });
    });
  }
}
